/**
 * add accordion functionality for menu items to .s-footer selector
 */
import jQuery from 'jquery'
import * as lib from '../lib/lib'

export default class ContentReadMore {
  constructor(element) {
    if (!element) {
      return false
    }

    this.$element = jQuery(element)
    this.body = jQuery('.b-content-read-more__body', this.$element)
    this.buttonViewMore = jQuery('.js-view-more', this.$element)
    this.buttonViewLess = jQuery('.js-view-less', this.$element)

    this.buttonViewMore.on('click', () => {
      this._toggleContent()
    })

    this.buttonViewLess.on('click', () => {
      this._toggleContent()
    })

    jQuery(window).on('resize', () => {
      if (lib.scrDesktops() && !this.$element.hasClass('all-devices')) {
        this.body.removeAttr('style')
        this.$element.removeClass('is-active')
      }
    })
  }

  _toggleContent() {
    this.body.slideToggle(() => {
      if (this.body.css('display') === 'none') {
        this.body.removeAttr('style')
      }
    })
    this.$element.toggleClass('is-active')

    if (this.$element.hasClass('is-active')) {
      jQuery('.b-content-read-more.is-active')
        .siblings('p')
        .last()
        .css('transition', 'margin 0.2s linear 0.1s')
        .css('margin-bottom', '0')
    } else {
      jQuery(this.$element)
        .siblings('p')
        .last()
        .css('transition', 'margin 0.2s linear 0.1s')
        .css('margin-bottom', 'revert')
      setTimeout(() => {
        jQuery(this.$element).siblings('p').last().removeAttr('style')
      }, 300)
    }
  }
}
